<ng-container *ngIf="action$ | async"></ng-container>

<div id="fastener-bse-point-select" cslPerfectScrollbar class="flex flex-col items-stretch flex-1">
  <div class="h-full flex flex-row items-stretch">
    <div class="pr-3 control-panel-wrapper flex flex-col space-y-2 items-stretch basis-[400px]">
      <div class="fasteners-set-icon-wrapper flex flex-row justify-center items-center" *ngIf="hasImage()">
        <img class="fasteners-set-icon" src="{{ fastenersSetIconLink }}" alt="Fastener set icon" />
      </div>

      <mat-checkbox [(ngModel)]="hasMirroredHoles" (ngModelChange)="holeFormChanged(data)">
        <div class="flex flex-row flex-wrap space-x-2 items-center">
          <div i18n>Добавить симметрично по</div>
          <mat-form-field appearance="outline" class="micro-input no-subscript no-label">
            <mat-select
              [(ngModel)]="mirrorAxis"
              (ngModelChange)="holeFormChanged(data)"
              (click)="$event.stopPropagation(); $event.preventDefault()">
              <mat-option [value]="'x'">x</mat-option>
              <mat-option [value]="'y'">y</mat-option>
              <mat-option [value]="'xy'">xy</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-checkbox>

      <ng-container
        *ngIf="
          isFastenersSet(fastener)
            ? fastener?.type !== thisPositioningTypeEnum.OnSide
            : fastener?.type === thisCustomHoleSchemaTypeEnum.Plate;
          then plateHoleTemplate;
          else edgeHoleTemplate
        ">
      </ng-container>

      <ng-template #plateHoleTemplate>
        <csl-countertop-plate-hole-form
          #holeForm
          [side]="side"
          (formChanged)="holeFormChanged($event)"
          [selectedMultiSide]="selectedMultiSide"
          [point]="selectedPoint"
          [availablePlate]="availablePlate"
          [fullMaterialThickness]="fullMaterialThickness"
          [panelHeight]="countertop.length"
          [panelWidth]="countertop.width"
          *ngIf="data && fastener"
          [data]="data"
          [fastener]="fastener"
          class="flex-1">
        </csl-countertop-plate-hole-form>
      </ng-template>
      <ng-template #edgeHoleTemplate>
        <csl-countertop-edge-hole-form
          #holeForm
          (formChanged)="holeFormChanged($event)"
          [side]="side"
          [availablePlate]="availablePlate"
          [selectedMultiSide]="selectedMultiSide"
          [point]="selectedPoint"
          [panelHeight]="countertop.length"
          [panelWidth]="countertop.width"
          *ngIf="data && fastener"
          [data]="data"
          [fastener]="fastener">
        </csl-countertop-edge-hole-form>
      </ng-template>
    </div>

    <div class="flex-auto overflow-hidden">
      <csl-countertop-schema #edgeSchema class="h-full w-[550px] block overflow-hidden"></csl-countertop-schema>
    </div>
  </div>
</div>
